import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-title-container"
}
const _hoisted_2 = { class: "main-wr" }
const _hoisted_3 = { class: "house-upgrades" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderEstimatorStepTitle"], { title: `Upgrades & Promotions` })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($setup.isDesktop)
          ? (_openBlock(), _createBlock($setup["BuilderEstimatorHouseUpgradeOptionDesktop"], {
              key: 0,
              optionalUpgrades: $setup.props.optionalUpgrades,
              selectedUpgradeFromForm: $props.selectedUpgradeFromForm,
              handleUpgradeSelection: $setup.handleUpgradeSelection
            }, null, 8, ["optionalUpgrades", "selectedUpgradeFromForm"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.props.optionalUpgrades, (option) => {
              return (_openBlock(), _createBlock($setup["UpgradeOption"], _mergeProps({
                key: option._id
              }, { ref_for: true }, option, {
                "is-selected": $props.selectedUpgradeFromForm?.some((u) => u._id === option._id) || false,
                "onUpdate:selected": (value) => $setup.handleUpgradeSelection(option, value)
              }), null, 16, ["is-selected", "onUpdate:selected"]))
            }), 128))
      ])
    ])
  ], 64))
}